module.exports = __webpack_public_path__ + "static/media/raid_forum_theme_2.8e8fd1ea.jpg";